'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';

import { SvgIconWrapper, Typography } from 'lighthouse';
import { ChevronLeftOffOutlineMdSVG } from 'lighthouse-icons';

import LoginModal from '@/widgets/LoginModal';

import { useProfile } from '@/hooks/user/useProfile';

import { isUserLogin } from '@/utilities/CheckUserIsLogin';

import { azkivamProPayStatus } from '@/constants/azkivamProPay';

import { AzkivamProPayModal } from './components/AzkivamProPayModal';
import { AzkivamProPayBannerProps, stepsValue } from './models';

import { GetProfileResponseType } from '@/client/services/core/user/models';

export const AzkivamProPayBanner = ({ contentData }: AzkivamProPayBannerProps) => {
    const isLogin = isUserLogin();
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [isAzkivamModal, setIsAzkivamModal] = useState(false);

    const [stepValue, setStepValue] = useState<stepsValue>(null);

    const [isProfileLoading, setisProfileLoading] = useState(true);

    const { profile, loadProfile: mutateLoadProfile } = useProfile({ shouldFetchProfile: false });

    const handleCloseLoginModal = async () => {
        setShowLoginModal(false);
    };

    const onClickHandler = () => {
        if (!isLogin) {
            setShowLoginModal(true);
        } else {
            if (profile) {
                if (profile?.propay.status === azkivamProPayStatus.SUCCESS) {
                    setStepValue('allocated_credit');
                    setIsAzkivamModal(true);
                } else if (profile?.propay.status === azkivamProPayStatus.FAILED && !profile.propay.isRecentRequestWindowPassed) {
                    setStepValue('national_code_error');
                    setIsAzkivamModal(true);
                } else {
                    setIsAzkivamModal(true);
                    setStepValue('welcome');
                }
            }
        }
    };

    const loadProfile = async (): Promise<GetProfileResponseType | null> => {
        try {
            const profileResponse = await mutateLoadProfile();
            return profileResponse;
        } catch (error) {
            return null;
        } finally {
        }
    };

    const handleSubmitPropay = async () => {
        await loadProfile();
    };

    const loginHandler = async () => {
        try {
            const profileResponse = await loadProfile();

            const propayStatus = profileResponse && profileResponse.propay;

            if (propayStatus?.status === azkivamProPayStatus.SUCCESS) {
                setStepValue('allocated_credit');
            } else if (propayStatus?.status === azkivamProPayStatus.FAILED && !propayStatus.isRecentRequestWindowPassed) {
                setStepValue('national_code_error');
            } else {
                setStepValue('welcome');
            }

            setIsAzkivamModal(true);
        } catch (error) {
            return null;
        } finally {
            setShowLoginModal(false);
        }
    };

    useEffect(() => {
        setisProfileLoading(true);
        if (isLogin) {
            loadProfile();
        }
        setisProfileLoading(false);
    }, [isLogin]);

    const modalCloseHandler = async () => {
        setIsAzkivamModal(false);
    };

    if (!contentData.showBanner) {
        return null;
    }

    return (
        <div className='mx-auto max-w-3xl'>
            <button
                onClick={onClickHandler}
                disabled={isProfileLoading}
                className={`${isProfileLoading ? 'cursor-not-allowed' : ''} mt-4 h-[78px] w-full cursor-pointer overflow-hidden rounded-lg border-none
                    bg-[url(/images/azkivamPropay/creditThirdPartyCompare.svg)] bg-cover bg-center bg-no-repeat px-4 shadow-elevation1 transition-all
                    duration-300 hover:-translate-y-0.5 hover:shadow-elevation2`}>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center justify-start'>
                        <Image src={'/images/azkivamPropay/creditCard.svg'} alt='' width={38} height={38} />

                        <Typography
                            variant='subtitle1'
                            component='span'
                            className={`${!profile && isProfileLoading ? 'animate-pulse select-none rounded-lg bg-[#63a0e1] text-[#63a0e1]' : 'text-white'}
                                mr-2`}>
                            {profile?.propay.status === azkivamProPayStatus.SUCCESS
                                ? `خرید اقساطی با اعتبار ازکی‌وام`
                                : 'دریافت اعتبار خرید | 10,000,000  تومان'}
                        </Typography>
                    </div>

                    <SvgIconWrapper
                        icon={ChevronLeftOffOutlineMdSVG}
                        size='md'
                        className={!profile && isProfileLoading ? 'animate-pulse rounded-lg bg-[#63a0e1] text-[#63a0e1]' : ''}
                        color='white'
                    />
                </div>
            </button>

            {isAzkivamModal && profile && (
                <AzkivamProPayModal
                    phoneNumber={profile.phoneNumber}
                    step={stepValue}
                    setStep={(step) => setStepValue(step)}
                    onSubmitModal={handleSubmitPropay}
                    onClose={modalCloseHandler}
                />
            )}

            {showLoginModal && <LoginModal onUserLogin={loginHandler} onClose={handleCloseLoginModal} />}
        </div>
    );
};
